import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './components/hooks/useAuth';
import Home from './components/Home';
import Contact from './components/contact';
import Sign from './components/Signup';
import Login from './components/Login';
import Pass from './components/password';
import Road from './components/Roadmap';
import LayoutWithDash from './components/Layout';
import LayoutWithoutDash from './components/Layoutwithout';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import BlogList from './components/blogList';
import BlogPost from './components/BlogPost'
import T from './components/Text';
import CourseList from './components/learning/CourseList';
import CourseDetail from './components/learning/CourseDetail';
import CourseQuiz from './components/learning/CourseQuiz';
import CourseInterview from './components/learning/CourseInterview';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ToastContainer position="top-right" theme="dark" />
        <Routes>
          {/* Routes with Dash */}
          <Route element={<LayoutWithDash />}>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/roadmap" element={<Road />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Route>

          {/* Routes without Dash */}
            <Route element={<LayoutWithoutDash />}>
            <Route path="/signup" element={<Sign />} />
            <Route path="/login" element={<Login />} />
            <Route path="/pass" element={<Pass />} />
            <Route path="/learning" element={<CourseList />} />
            <Route path="/learning/courses/:courseId" element={<CourseDetail />} />
            <Route path="/learning/courses/:courseId/quiz" element={<CourseQuiz />} />
            <Route path="/learning/courses/:courseId/interview" element={<CourseInterview />} />
            <Route path="/write" element={<T />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;